export enum ProfessionalTypes {
  GETALL = '@professional/GETALL',
  GETALL_SUCCESS = '@professional/GETALL_SUCCESS',
  GETALL_FAILED = '@professional/GETALL_FAILED',
  CREATE = '@professional/CREATE',
  CREATE_SUCCESS = '@professional/CREATE_SUCCESS',
  CREATE_FAILED = '@professional/CREATE_FAILED',
}
